import React from "react";
import {Menu} from "antd";
import {Link} from "react-router-dom";

import {connect} from "react-redux";
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../../constants/ThemeSetting";
import IntlMessages from "../../../util/IntlMessages";
import {useSelector} from "react-redux";
const MenuItemGroup = Menu.ItemGroup;
const SidebarContent = ({sidebarCollapsed, setSidebarCollapsed,auth}) => {
  const {navStyle, themeType} = useSelector(({settings}) => settings);
  const pathname = useSelector(({common}) => common.pathname);

  const getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];

  return (
    <>
      <SidebarLogo sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed}/>
      <div className="gx-sidebar-content">
        <div className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}>
          <UserProfile/>
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
            mode="inline">

            <Menu.Item key="dashboard">
              <Link to="/exeemployee/dashboard"><i className="icon icon-apps"/>
                <span><IntlMessages id="sidebar.dashboard"/></span>
              </Link>
            </Menu.Item>
            <Menu.Item key="projects">
              <Link to="/exeemployee/checkInOut"><i className="icon icon-widgets"/>
                <span><IntlMessages id="sidebar.clockInOut"/></span>
              </Link>
            </Menu.Item>
           
      
            <Menu.Item key="employees">
              <Link to="/exeemployee/employees"><i className="icon icon-profile2"/>
                <span><IntlMessages id={auth.authR.user.role=="executive"?"sidebar.employees":"sidebar.team"}/></span>
              </Link>
            </Menu.Item>

      
            <MenuItemGroup key="sales" className="gx-menu-group" title={<span style={{color:"white"}}>Project</span>}>

            <Menu.Item key="sales">
              <Link to="/exeemployee/projects"><i className="icon icon-home"/>
                <span><IntlMessages id="sidebar.projects"/></span>
              </Link>
            </Menu.Item>
            <Menu.Item key="createproject">
              <Link to="/exeemployee/createproject"><i className="icon icon-add-circle"/>
                <span><IntlMessages id="sidebar.createproject"/></span>
              </Link>
            </Menu.Item>
            
            </MenuItemGroup>


<MenuItemGroup key="order" className="gx-menu-group" title={<span style={{color:"white"}}>CRM</span>}>

<Menu.Item key="customers">
  <Link to="/exeemployee/customers"><i className="icon icon-profile"/>
    <span><IntlMessages id="sidebar.customers"/></span>
  </Link>
</Menu.Item>

</MenuItemGroup>
            <Menu.Item key="Files">
              <Link to="/exeemployee/files"><i className="icon icon-files"/>
                <span><IntlMessages id="sidebar.files"/></span>
              </Link>

            </Menu.Item>

          <Menu.Item key="MyFiles">
              <Link to="/exeemployee/myfiles"><i className="icon icon-files"/>
                <span>My Files</span>
              </Link>

            </Menu.Item>
    
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};


const mapStateToProps = state => ({
  auth: state,

})

const Index=connect(mapStateToProps)(SidebarContent)

export default React.memo(Index);

